document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'tcb-contact-prefill';
  var ALLOWED_FIELDS = {
    company: true,
    first_name: true,
    email: true,
    phone: true,
    zip: true,
    state: true,
    product: true,
    sku: true,
    topic: true,
    model: true,
    part_number: true,
    year: true,
    serial: true,
    make: true,
    description: true
  };

  document.querySelectorAll('form[data-tcb-lead-transfer]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var payload = {};
      var topicInput = form.querySelector('input[name="topic"]');
      if (topicInput && topicInput.value) {
        payload.topic = topicInput.value;
      }

      form.querySelectorAll('input[name], select[name], textarea[name]').forEach(function (field) {
        if (!field.name || field.name === 'topic') return;
        if (!ALLOWED_FIELDS[field.name]) return;
        if (field.type === 'hidden' && field.name !== 'topic') return;
        payload[field.name] = field.value;
      });

      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
      } catch (e) {
        /* ignore storage failures */
      }

      var target = form.getAttribute('data-tcb-lead-target') || '/pages/contact?topic=quote#tcb-contact-form';
      if (window.TcbSecurity && !window.TcbSecurity.isSafeContactPath(target)) {
        target = '/pages/contact?topic=quote#tcb-contact-form';
      }

      window.location.assign(target);
    });
  });
});
